module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-51-min.13753989.jpg";